import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../../components/common/Modal";
import Button from "../../../components/Button";
import TextArea from "../../../components/TextArea";
import { updateProjectRequestStatus } from "../../../api/project";
import { toast } from "react-toastify";

interface FormData {
  comment: string;
}

interface AskResubmitModalProps {
  setShowAskResubmitModal: (value: boolean) => void;
  getSingleProjectData: () => void;
  projectId: string;
}

const AskResubmitModal = ({
  setShowAskResubmitModal,
  getSingleProjectData,
  projectId,
}: AskResubmitModalProps) => {
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm<FormData>({
    defaultValues: {
      comment: "",
    },
  });

  const watchedComment = watch("comment");

  const handleClose = () => {
    setShowAskResubmitModal(false);
  };

  const onSubmit = async (data: FormData) => {
    setLoading(true);
    try {
      const payload = {
        status: "REJECTED",
        review_comments: data.comment,
      };

      await updateProjectRequestStatus(projectId, payload);

      toast.success("Project has been rejected successfully.");

      getSingleProjectData();
      handleClose();
    } catch (error: any) {
      console.error("Error submitting form:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.errors ||
        "Failed to process request";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        header="Re Submit Form comments"
        footer={
          <div className="flex gap-4 w-full">
            <Button
              label={"Send"}
              variant="secondary"
              onClick={handleSubmit(onSubmit)}
              disabled={loading}
            />
            <Button
              label={"Cancel"}
              variant="secondary-text"
              onClick={handleClose}
              disabled={loading}
            />
          </div>
        }
        handleCancel={handleClose}
      >
        <form onSubmit={handleSubmit(onSubmit)} className="w-full">
          <div className="flex w-full my-4">
            <TextArea
              {...register("comment", {
                required: "Comment is required",
                minLength: {
                  value: 10,
                  message: "Comment must be at least 10 characters long",
                },
              })}
              value={watchedComment}
              onChange={(e: any) => {
                setValue("comment", e, { shouldValidate: true });
              }}
              disabled={loading}
              placeholder="Add comments"
              label="Add comments"
              className="w-full"
              rows={4}
              required
              hint={errors?.comment?.message}
            />
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default AskResubmitModal;
